// HeroSection.js
import React from "react";
import "../scss/hero.css";

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-overlay">
        <h1>24/7 Bike Roadside Assistance & Doorstep Service in Chennai</h1>
        <p>
          Flat tire, battery trouble, or breakdown? Get instant help, towing, and professional bike service anywhere in
          Chennai — just a tap away.
        </p>
        <button className="cta-button" onClick={() => window.open("/rider", "_blank")}>
          Download MotoDoctor App{" "}
        </button>
      </div>
    </section>
  );
};

export default Hero;
